<template>
  <div class="main">
    <nav-bar title="活动规则"></nav-bar>
    <div class="rule" v-html="rule"></div>
  </div>
</template>

<script>
import mixin from "./mixin";
import NavBar from "./components/navbar.vue";

export default {
  mixins: [mixin],
  components: {
    NavBar,
  },
  created() {
    this.$api
      .get("cms-v2/index/agreement/app/detail", { number: "CJHDGZ" })
      .then((res) => {
        this.rule = res.content;
      });
  },
  data() {
    return {
      rule: null,
    };
  },
};
</script>

<style lang="less" scoped>
.main {
  min-height: 100vh;
  background: #f5f6f7;
}

.rule {
  padding: 1.9rem 1.2rem;
  font-size: 1.5rem;
  line-height: 2.4rem;
}
</style>
